import React, { useState, useEffect, useRef } from 'react';
import {
  TextInputSkeleton,
  TextInput,
  NumberInput,
  FormGroup,
  Toggle,
  Modal,
  Grid,
  Column
} from '@carbon/react';
import { useGetFeaturesQuery } from '@/redux/new_services/features';
import { parseFeatureSettings } from '@/lib/featureSettings';
import CustomSelect from '../SelectComponent';

const RenderInputField = ({ setting, value, onChange, refToModal }) => {
  switch (setting.type) {
    case 'options': {
      let items = setting.options.map((i) => {
        return { id: i.value, text: i.name, uuid: i.uuid };
      }).sort((a, b) => a.text.localeCompare(b.text));

      return (
        <CustomSelect
          selection = {[value]}
          onSelectionChange = {(new_selection) => {onChange(setting.id, new_selection[0])}}
          items = {items.map(i => ({value: i.id, label: i.text}))}
          refToModal={refToModal}
        />
      )

      /*return (
        <Select
          id={setting.id}
          labelText={setting.name}
          helperText={setting.info}
          value={value}
          onChange={(e) => onChange(setting.id, e.currentTarget.value)}
          data-field="mode"
          data-valuetype="string">
          <SelectItem text="Eintrag auswählen..." value={0} />
          {items.map((i) => {
            return (
              <SelectItem
                key={`form_mode_select_item_${i.uuid}`}
                text={i.text}
                value={i.id}
                //selected={}
              />
            );
          })}
        </Select>
      );*/
    }
    case 'string_ip':
      return (
        <TextInput
          type="text"
          id={setting.id}
          labelText={setting.name}
          helperText={setting.info}
          onChange={(e) => onChange(setting.id, e.target.value)}
          value={value || setting.default}
        />
      );

    case 'number': {
      const v = value ? value : parseInt(setting.default);
      return (
        <NumberInput
          id={setting.id}
          label={setting.name}
          helperText={setting.info}
          onChange={(_e, {value, direction}) => {
            if (value > 0) {
              onChange(setting.id, parseInt(value));
            } else {
              onChange(
                setting.id,
                direction === 'up' ? v + 1 : direction === 'down' ? v - 1 : v
              );
            }
          }}
          allowEmpty={false}
          value={v}
        />
      );
    }
    case 'toggle':
    {
      const p = value ? value : parseInt(setting.default);
      return (
        <>
          <br />
          <Toggle
            id={setting.id}
            labelText={setting.name}
            labelA="Deaktivert"
            labelB="Aktiviert"
            onToggle={(t, _i) => {
              onChange(setting.id, t === true ? 1 : 0);
            }}
            toggled={p === 1}
          />
        </>
      );
    }
    default:
      return <TextInputSkeleton />;
  }
};

const FeatureSettings = ({ name, current_settings, onSubmit = () => {}, hideModal: onCloseForm }) => {

  const {data: features} = useGetFeaturesQuery();

  const [form, setForm] = useState([]);
  const [state, setState] = useState({});
  const [changed, setChanged] = useState(false);

  const [primary_button_text, setPrimyarybutton] = useState('Verlassen');

  useEffect(() => {
    if (features) {
      let f = features.find((e) => e.name === name);

      if (f && f.settings) {
        // Robustly decode the feature's settings schema; legacy rows may be
        // double JSON-encoded, which a single JSON.parse leaves as a string
        // and would break the `.map` render below.
        setForm(parseFeatureSettings(f.settings));
      }
    }
  }, [features, name]);

  useEffect(() => {
    if (changed === true) {
      setPrimyarybutton('Speichern');
    }
  }, [changed]);

  useEffect(() => {
    let temp_settings = current_settings;
    if (temp_settings) {
      if (typeof temp_settings === 'string' && temp_settings !== '') {
        temp_settings = JSON.parse(temp_settings);
      }
    } else {
      temp_settings = {};
    }

    let validated_settings = {};
    for (let f of form) {
      if (temp_settings[f.id]) {
        validated_settings[f.id] = temp_settings[f.id];
      } else {
        validated_settings[f.id] =
          f.type === 'number' ? parseInt(f.default) : f.default;
      }
    }

    setState(validated_settings);
  }, [current_settings, form]);

  const changeField = (id, value) => {
    setState(prev => ({ ...prev, [id]: value }));
    setChanged(true);
  };

  const onSubmitForm = () => {
    if (changed) {
      onSubmit(JSON.stringify(state));
    }

    onCloseForm();
  };

  const modalElement = useRef();

  return (
    <Modal
      ref={modalElement}
      open={true}
      danger={false}
      size="lg"
      primaryButtonText={primary_button_text}
      secondaryButtonText={'Abrechen'}
      modalHeading="Feature Einstellungen"
      onRequestClose={onCloseForm}
      onRequestSubmit={onSubmitForm}
      hasScrollingContent
      aria-label="Feature Einstellungen Content">
      <Grid fullWidth>
        <Column sm="100%" md="100%" lg="100%">
          <FormGroup legendText="">
            {form.map((setting) => (
              <RenderInputField
                key={`input_${setting.id}_group`}
                setting={setting}
                value={state[setting.id]}
                onChange={changeField}
                refToModal={modalElement}
              />
            ))}
          </FormGroup>
        </Column>
      </Grid>
    </Modal>
  );
};

export default FeatureSettings;
